export default __webpack_public_path__ + "static/media/8.9cd3e16f.jpg";